import { Box, Collapse, Grid, List, ListItem, styled } from "@mui/material";
import useModal from "@rf/base/modal/useModal";
import MxModalTemplate2 from "@rf-l1/modal/MxModalTemplate2";
import MxTypography from "@rf-l1/MxTypography";
import { memo, useMemo, useState } from "react";
import {
  A_PROPERTY_TYPES_FOR_PROJECT,
  A_REALESTATE_TYPES
} from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";

import PropertyIcon from "@icons-rf/realestate/property-icon.svg?react";
import ProjetIcon from "@icons-rf/realestate/project-icon.svg?react";
import theme from "@/shared/theme/theme";
import { useNavigate } from "react-router-dom";
import { C_PATH_ROUTES } from "@/src-refactor/modules/shared/model/const/path.const";
import { useStatsSlice } from "@/src-refactor/modules/store/redux/stats/stats.slice";
const usePropertyCreateSelectType = () => {
  const { modal } = useModal();

  const handleOpenModal = () => {
    modal({
      template: <PropertyCreateSelectTypeTemplate />,
      options: {
        title: "",
        size: {
          xs: {
            width: "100%",
            height: "100%"
          },
          sm: {
            width: "100%",
            height: "100%"
          },
          md: {
            width: "100%"
          },
          lg: {
            width: "700px"
          },
          xl: {
            width: "600px"
          }
        }
      }
    }).then(data => {
      if (data.type.confirm) {
      }
    });
  };

  return { handleOpenModal };
};

const PropertyCreateSelectTypeTemplate = () => {
  const { onConfirm, getData } = useModal();
  const navigate = useNavigate();

  const [activeType, setActiveType] = useState<"property" | "project" | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const onSelect = (type: "property" | "project") => {
    if (activeType == type) {
      setIsOpen(false);
      setTimeout(() => {
        setActiveType(null);
      }, 300);
      return;
    }
    setActiveType(type);
    setIsOpen(true);
  };

  const entriesProperties = useMemo(() => {
    return Object.entries(A_REALESTATE_TYPES)
      .map(item => item[1])
      .filter(item => {
        return item.value !== "project";
      });
  }, []);

  const entriesProjects = useMemo(
    () => Object.entries(A_PROPERTY_TYPES_FOR_PROJECT).map(item => item[1]),
    []
  );

  const GoToCreate = (item: I_GENERIC_ITEMS) => {
    if (activeType === "property") {
      navigate(`${C_PATH_ROUTES.REALESTATE.CREATE}?type=${item.id}`);
    } else {
      navigate(`${C_PATH_ROUTES.REALESTATE.PROJECT_CREATE}?type=${item.id}`);
    }
    onConfirm();
  };

  return (
    <MxModalTemplate2
      children={
        <Grid
          container
          px={{
            xs: 0,
            sm: 2,
            md: 6,
            lg: 6,
            xl: 6
          }}
        >
          <Grid item xs={12} sx={{ textAlign: "center" }}>
            <MxTypography variant="h6" color={"primary.main"}>
              ¿Qué tipo de propiedad subirás hoy?
            </MxTypography>
          </Grid>
          <Grid
            display={"grid"}
            gridTemplateColumns={"repeat(2, 1fr)"}
            width={"100%"}
            columnGap={2}
            my={2}
          >
            <ButtonCard
              onClick={() => onSelect("property")}
              isActive={activeType === "property"}
            >
              <PropertyIcon />
              <MxTypography
                color={activeType === "property" ? "white" : "primary.main"}
                variant="subtitle2"
                fontWeight={600}
              >
                Una Propiedad
              </MxTypography>
            </ButtonCard>

            <ButtonCard
              onClick={() => onSelect("project")}
              isActive={activeType === "project"}
            >
              <ProjetIcon />
              <MxTypography
                color={activeType === "project" ? "white" : "primary.main"}
                variant="subtitle2"
                fontWeight={600}
              >
                Un Proyecto
              </MxTypography>
            </ButtonCard>
          </Grid>
          <Grid item xs={12}>
            {!activeType && <GoToDraftList />}
          </Grid>
          {activeType && (
            <Grid
              item
              xs={12}
              minHeight="100%"
              mb={2}
              sx={{ textAlign: "center" }}
              className="slide-up"
            >
              <MxTypography variant="subtitle2" color={"primary.main"}>
                Seleccione el tipo de propiedad
              </MxTypography>
            </Grid>
          )}
          <Grid item xs={12}>
            <Collapse in={isOpen}>
              <Grid container>
                {activeType === "property" && (
                  <Grid item xs={12}>
                    <RenderListOptions
                      items={entriesProperties}
                      onClick={GoToCreate}
                    />
                  </Grid>
                )}
                {activeType === "project" && (
                  <Grid item xs={12}>
                    <RenderListOptions
                      items={entriesProjects}
                      onClick={GoToCreate}
                    />
                  </Grid>
                )}
              </Grid>
            </Collapse>
          </Grid>
        </Grid>
      }
    />
  );
};

export default usePropertyCreateSelectType;

const ButtonCard = styled(Grid)<{ isActive: boolean }>(
  (props: { isActive: boolean }) => {
    const active = props.isActive
      ? `background: ${theme.palette.primary.main};
      color: white;
      svg: {
          fill: #FFFFFF;
          color: #FFFFFF;
      }`
      : `
      background: #FFFFFF;
      color: ${theme.palette.primary.main};
      svg: {
          fill: ${theme.palette.primary.main};
          color: ${theme.palette.primary.main};
      }
      `;

    return `
      ${active}
      
      border: 1px solid ${theme.palette.grey[300]};
        transition: all 0.2s ease-in-out;  
      border-radius: 10px;
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 10px;
      svg{
          width: 60%;
          height: 60%;
      }
      cursor: pointer;
      &:hover {
        transform: scale(1.05);
      }
  `;
  }
);

interface IRenderListOptionsProps {
  items: I_GENERIC_ITEMS[];
  onClick: (item: I_GENERIC_ITEMS) => void;
}

const RenderListOptions = memo(({ items, onClick }: IRenderListOptionsProps) => {
  const handleClick = (item: I_GENERIC_ITEMS) => {
    onClick(item);
  };
  return (
    <List
      sx={{
        width: "100%",
        overflow: "auto",
        // maxHeight: "210px",
        border: "1px solid #ccc",
        borderRadius: "10px",
        padding: "10px",
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        columnGap: "30px",
        [theme.breakpoints.down("sm")]: {
          gridTemplateColumns: "repeat(1, 1fr)"
        }
      }}
    >
      {items.map(item => (
        <ListItem
          key={item.id}
          onClick={() => handleClick(item)}
          sx={{
            borderBottom: "1px solid #ccc",
            "&:last-child": {
              borderBottom: "none"
            },
            padding: "10px",

            cursor: "pointer",
            "&:hover": {
              borderRadius: "5px",
              backgroundColor: theme.palette.primary.main,
              "& .MuiTypography-root": {
                color: "white"
              }
            }
          }}
        >
          <MxTypography variant="caption" color={"primary.main"} fontWeight={600}>
            {item.label}
          </MxTypography>
        </ListItem>
      ))}
    </List>
  );
});

const GoToDraftList = memo(() => {
  const { stats } = useStatsSlice();

  const navigate = useNavigate();
  const { onConfirm } = useModal();

  const onSelectDraft = () => {
    navigate(C_PATH_ROUTES.REALESTATE.DRAFT_LIST);
    onConfirm();
  };
  if (!stats.countDrafts) return null;
  return (
    <Grid
      container
      px={{
        xs: 0,
        sm: 2,
        md: 6,
        lg: 6,
        xl: 6
      }}
      mt={2}
    >
      <Grid item xs={12} sx={{ textAlign: "center" }}>
        <MxTypography variant="subtitle2" color={"grey.600"} fontWeight={500}>
          O continúa desde un{" "}
          <span
            onClick={onSelectDraft}
            style={{
              color: theme.palette.primary.main,
              textDecoration: "underline",
              cursor: "pointer"
            }}
          >
            borrador
          </span>
        </MxTypography>
      </Grid>
    </Grid>
  );
});
